import store from './../../store';
import moment from 'moment';
import customerService from './../../services/customer';
import Vue from 'vue';

export default {
  data() {
    return {
      form: {
        refCode: '',
        name: '',
        phoneNumber: '',
        email: '',
        customerGroup: {},
      },
      customerDialog: false,
      rules: {
        customerGroup: [{type: 'number', required: true, message: "Please select customer group", trigger: 'change'}]
      },
    }
  },
  props: {
    dialogVisible: Boolean,
    closeDialog: Function
  },
  mounted() {
    store.dispatch('group/getGroup', {});
  },
  computed: {
    count: function() {
      return store.state.customer.count
    },
    groups: function() {
      return store.state.group.groups
    }
  },
  watch: {
    dialogVisible(val) {
      this.customerDialog = val;
      if(val) {
        this.form.refCode = 'C-' + moment().format('YYDD') + '-' + (this.count + 1)
      }
    },
    customerDialog(val) {
      if (!val) {
        this.closeDialog();
      }
    },
  },
  methods: {
    // Submit and close the form
    onSubmitClose(form) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.customerDialog = false;
          customerService.create($.extend({}, form));
          this.form = {};
        } else {
          return false;
        }
      });
    },
    onSubmit(form) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.customerDialog = false;
          customerService.create($.extend({}, form), (err, res) => {
            if(err) return console.log(err);
            Vue.router.push({name: 'customer.edit', params: {id: res.data.id}})
            return;
          });
          this.form = {};
        } else {
          return false;
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/customer/create-dialog.js